import { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import TopBack from "../reservations/components/subcompdash/Topback";

function CustomerApprovalRequests() {
    const [datas] = useState(null);

    // firestore.collection('Users').orderBy('serialID', 'asc').onSnapshot((snapshot) => {
    //     const postData = [];
    //     snapshot.forEach((doc) => {
    //         //   if (
    //         //     doc.data().isApproved &&
    //         //     doc.data().isCarSelected &&
    //         //     !doc.data().isCarPickedUp
    //         //   )
    //         if (
    //             !doc.data()?.status?.isApproved
    //     && !doc.data()?.status?.isReviewed
    //     && doc.data()?.status?.isApplied
    //         ) {
    //             postData.push({ ...doc.data(), id: doc.id });
    //         }
    //     });
    //     setDatas(postData);
    // });

    // return setDatas(null);

    const [pageNumber, setPageNumber] = useState(0);
    const usersPerPage = 17;
    const pagesVisited = pageNumber * usersPerPage;
    const displayUsers =
        datas &&
        datas.slice(pagesVisited, pagesVisited + usersPerPage).map((user) => (
            <tbody key={user.serialID}>
                <tr className="fontSemi bodytt">
                    <td style={{ width: "14rem" }}>
                        {user.serialID < 1000 && user.serialID > 99
                            ? `0${user.serialID}`
                            : user.serialID < 100 && user.serialID > 9
                              ? `00${user.serialID}`
                              : `000${user.serialID}`}
                        {/* {user.id} */}
                    </td>
                    <td style={{ width: "25rem" }}>
                        {user.name} {user?.status?.isApproved && "✅"}{" "}
                        {user?.status?.isReviewed && !user?.status?.isApproved && "⏳"}
                    </td>
                    <td>{user.email}</td>
                    <td>{user.mobileNumber}</td>
                    <td>{user.license && user.license.number}</td>
                    <td style={{ width: "8rem" }}>
                        <Link style={{ textDecoration: "none" }} to={`/customers/${user.id}`}>
                            <div className="viewbb fontbold">View</div>
                        </Link>
                    </td>
                </tr>
            </tbody>
        ));

    const pageCount = datas && Math.ceil(datas.length / usersPerPage);
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };
    return (
        <>
            <TopBack />
            <div className="flex min-h-0 flex-1 flex-col">
                <div
                    style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}>
                    <div className="text-[1.2rem] fontbold">
                        Customer Approval Requests <span className="text-[#5d5dff]">({datas && datas.length})</span>
                    </div>
                    <div style={{ height: "42rem" }}>
                        <table className="ttcont">
                            <tbody>
                                <tr className="fontRegular headtt">
                                    <th style={{ width: "10rem" }}>ID</th>
                                    <th style={{ width: "15rem" }}>Customer name</th>
                                    <th style={{ width: "18rem" }}>E-mail</th>
                                    <th>Phone</th>
                                    <th>License no.</th>
                                    <th style={{ width: "8rem" }} />
                                </tr>
                            </tbody>
                            {displayUsers}
                        </table>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            color: "#acacb9",
                            justifyContent: "space-between",
                            width: "75rem",
                            flex: "1",
                            alignItems: "end",
                        }}>
                        <div className="info fontLight" style={{ margin: "12px 0" }}>
                            Page {pageNumber + 1} of {pageCount} pages | {pagesVisited + 1}-
                            {datas && Math.min(datas.length, pagesVisited + usersPerPage)} items of total{" "}
                            {datas && datas.length} items
                        </div>
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination fontRegular"}
                            activeClassName={"paginateactive"}
                            previousLinkClassName={"previousP"}
                            nextLinkClassName={"nextP"}
                            breakLabel={"..."}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default CustomerApprovalRequests;
